__turbopack_context__.v({
  "TagDefault": "Tag-module__-ohBnG__TagDefault",
  "TagError": "Tag-module__-ohBnG__TagError",
  "TagInfo": "Tag-module__-ohBnG__TagInfo",
  "TagLarge": "Tag-module__-ohBnG__TagLarge",
  "TagMedium": "Tag-module__-ohBnG__TagMedium",
  "TagSmall": "Tag-module__-ohBnG__TagSmall",
  "TagSuccess": "Tag-module__-ohBnG__TagSuccess",
  "TagWarning": "Tag-module__-ohBnG__TagWarning",
  "tag": "Tag-module__-ohBnG__tag",
});
